import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-notes-modal',
  templateUrl: './notes-modal.component.html',
  styleUrls: ['./notes-modal.component.css']
})
export class NotesModalComponent implements OnInit {
  @Input() trip: any;
  @Output() onCloseModal = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }
  
  closeNotesModal(){
    this.onCloseModal.emit();
  }
}
